type DateInput = Date | string | number

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n)
}

function toDate(input: DateInput): Date {
  return input instanceof Date ? input : new Date(input)
}

export function formatDate(input: DateInput): string {
  const d = toDate(input)
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`
}

export function formatDateTime(input: DateInput): string {
  const d = toDate(input)
  const date = formatDate(d)
  return `${date} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`
}
